import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ChatbotActions } from './state/chatbot.actions';
import { Store } from '@ngxs/store';
import { ChatbotState } from './state/chatbot.state';
import { BreakpointObserver } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { distinctUntilChanged, map, startWith, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { mobileSlideState } from './animations/chatbot-animation';
import { TenantConfigService } from '../../../../../tenant-config/tenant-config.service';

@Component({
  selector: 'hf-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss'],
  animations: [mobileSlideState]
})
export class ChatbotComponent implements OnInit, OnDestroy {
  /** Optional override; defaults to the tenant's assistant name. */
  @Input() chatbotName?: string;
  chatbot$ = this.store.select(ChatbotState.chatbotState);
  private destroy$ = new Subject<void>();

  constructor(
    private readonly store: Store,
    private readonly bp: BreakpointObserver,
    public readonly tenantConfigService: TenantConfigService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  ngOnInit(): void {
    // watch viewport ≤ 935px and dispatch once + on change
    if (isPlatformBrowser(this.platformId)) {
      this.bp
        .observe(['(max-width: 935px)'])
        .pipe(
          startWith(this.bp.isMatched('(max-width: 935px)') ? { matches: true } : { matches: false }),
          map((r) => r.matches),
          distinctUntilChanged(),
          takeUntil(this.destroy$)
        )
        .subscribe((isMobile) => {
          this.store.dispatch(new ChatbotActions.MobileTagView(isMobile));
        });
    }
    this.store.dispatch(new ChatbotActions.LoadLatest());
  }

  ngOnDestroy(): void {
    this.store.dispatch(new ChatbotActions.DisconnectWS());
    this.destroy$.next();
    this.destroy$.complete();
  }

  public openChatbot() {
    const isMinimised = this.store.selectSnapshot(ChatbotState.isMinimised);
    this.store.dispatch(new ChatbotActions.ToggleMinimise(!isMinimised));
    this.store.dispatch(new ChatbotActions.SetUnreadMessages(false));
  }
}
